var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineBuildings2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.15 18.75c-1.84 0-2.9-1.06-2.9-2.9V4.15c0-1.84 1.06-2.9 2.9-2.9h4.3c1.84 0 2.9 1.06 2.9 2.9V6c0 .41-.34.75-.75.75s-.75-.34-.75-.75V4.15c0-1.02-.38-1.4-1.4-1.4h-4.3c-1.02 0-1.4.38-1.4 1.4v11.7c0 1.02.38 1.4 1.4 1.4H6.7c.41 0 .75.34.75.75s-.34.75-.75.75H4.15z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12 22.75c-2.01 0-3.17-1.16-3.17-3.17V8.42c0-2.01 1.16-3.17 3.17-3.17h5.84c2.01 0 3.16 1.16 3.16 3.17v11.16c0 2.01-1.15 3.17-3.16 3.17H9.12zM7.45 8.42v11.16c0 1.2.47 1.67 1.67 1.67h5.84c1.19 0 1.66-.47 1.66-1.67V8.42c0-1.2-.47-1.67-1.66-1.67H9.12c-1.2 0-1.67.47-1.67 1.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.37 18.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2.48c1.02 0 1.4-.38 1.4-1.4V4.15c0-1.02-.38-1.4-1.4-1.4h-4.3c-1.02 0-1.4.38-1.4 1.4V6c0 .41-.34.75-.75.75s-.75-.34-.75-.75V4.15c0-1.84 1.06-2.9 2.9-2.9h4.3c1.84 0 2.9 1.06 2.9 2.9v11.7c0 1.84-1.06 2.9-2.9 2.9h-2.48z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4c.41 0 .75.34.75.75s-.34.75-.75.75h-4zM10 14.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4c.41 0 .75.34.75.75s-.34.75-.75.75h-4zM11.25 22v-3c0-.41.34-.75.75-.75s.75.34.75.75v3c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineBuildings2);
export default __webpack_public_path__ + "static/media/vuesax-outline-buildings-2.dc47580399e074612b258516d8bdf27d.svg";
export { ForwardRef as ReactComponent };